import classNames from "classnames";
import { forwardRef } from "react";
import { v4 as uuidv4 } from "uuid";
import Icon from "../../Icon";
import PrimeTooltip from "../../PrimeTooltip/PrimeTooltip";

import styles from "../Menu.module.css";

export interface SideBarLinkButtonProps {
  text: string;
  hideText?: boolean;
  icon: string;
  fillColor?: string;
  showTooltip?: boolean;
  truncateText?: boolean;
  dataCy?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  ariaHasPopup?: boolean;
  ariaExpanded?: boolean;
}

export const SideBarLinkButton = forwardRef<
  HTMLButtonElement,
  SideBarLinkButtonProps
>(
  (
    {
      text,
      hideText = false,
      icon,
      fillColor,
      showTooltip = false,
      truncateText = false,
      dataCy,
      onClick = undefined,
      onKeyDown,
      ariaHasPopup,
      ariaExpanded,
    },
    ref
  ) => {
    const uniqId = `id-${uuidv4()}`;
    return (
      <>
        <button
          ref={ref}
          id={uniqId}
          type="button"
          data-cy={dataCy}
          data-pr-tooltip={text}
          data-pr-at="right center-4"
          className={styles.sideBarLinkButton}
          onClick={(e) => onClick && onClick(e)}
          onKeyDown={onKeyDown}
          aria-label={text || "link"}
          aria-haspopup={ariaHasPopup || undefined}
          aria-expanded={ariaHasPopup ? ariaExpanded : undefined}
        >
          {fillColor ? (
            <div
              style={
                fillColor
                  ? {
                      backgroundColor: fillColor || "transparent",
                      width: 24,
                      height: 24,
                      borderRadius: 24,
                    }
                  : {}
              }
            />
          ) : (
            <Icon
              name={icon}
              size={24}
              color="Grey-500"
              className={styles.sideBarLinkIcon}
            />
          )}
          {!hideText ? (
            <span
              className={classNames({
                [styles.sideBarLinkButtonText]: true,
                [styles.truncateText]: truncateText,
              })}
            >
              {text}
            </span>
          ) : null}
        </button>
        {(showTooltip || truncateText) && (
          <PrimeTooltip target={`#${uniqId}`} position="right" theme="dark" />
        )}
      </>
    );
  }
);
